import { LATIN_MAP } from '@/const/latinMap';

export type NormalizeEventValueStyle = 'underscore' | 'dash';

/**
 * Normalizes an event value string for tracking (e.g. for mapping keys).
 * Returns the value unchanged if it is not a string.
 */
export function normalizeEventValue(value: unknown, style: NormalizeEventValueStyle): unknown {
  if (typeof value !== 'string') {
    return value;
  }
  if (style === 'underscore') {
    return value.toLowerCase().replace(/\s+|[-/]/g, '_');
  }
  const withDashes = value.toLowerCase().replace(/[^a-z0-9/_]+/g, '-');
  return withDashes.replace(/-+/g, '-');
}

export function convertToLatin(s: string) {
  return s.replace(/[^A-Za-z0-9\-_]/g, a => LATIN_MAP[a] || a);
}

/**
 * @see https://gist.github.com/dr-dimitru/9317130
 */
export function minifyHTML(s: string) {
  return s.replace(/([^\S ]\s*| \s{2,})(?=[^<]*(?:<(?!\/?(?:textarea|pre|script)\b)[^<]*)*(?:<(textarea|pre|script)\b| z))/, ' ');
}
